import { Box, Grid } from "@material-ui/core";
import { Title, useAuthenticated } from "react-admin";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ProLogsDateFnsUtils from "../../../common/datetime/ProLogsDateFnsUtils";
import { IdleReportProvider, useIdleReport } from "./IdleReportContext";
import { IdleReportDashboardPickers } from "./IdleReportDashboardPickers";
import { IdleReportBaseMetrics } from "./IdleReportBaseMetrics";
import AverageTimeWidget from "./AverageTimeWidget";
import TotalFuelSpentIdleWidget from "./TotalFuelSpentIdleWidget";
import IdleWorstPerformers from "./IdleWorstPerformers";
import IdleTimeSpentWidget from "./IdleTimeSpentWidget";
import IdleConsumptionWidget from "./IdleConsumptionWidget";
import IdleReportDriverTable from "./IdleReportDriverTable";

const IdleReportsContent = () => {
  useAuthenticated();
  const { reportParams } = useIdleReport();

  return (
    <div className="content-container">
      <Title title="resources.reports.idleReports.name" />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <IdleReportDashboardPickers />
        </Grid>

        <Grid item xs={12} md={5} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <IdleReportBaseMetrics {...reportParams} />
          </Box>
        </Grid>

        <Grid item xs={12} md={7} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <AverageTimeWidget {...reportParams} />
          </Box>
        </Grid>

        <Grid item xs={12} md={6} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <IdleTimeSpentWidget {...reportParams} />
          </Box>
        </Grid>

        <Grid item xs={12} md={6} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <IdleConsumptionWidget {...reportParams} />
          </Box>
        </Grid>

        <Grid item xs={12} md={4} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <TotalFuelSpentIdleWidget {...reportParams} />
          </Box>
        </Grid>

        <Grid item xs={12} md={8} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <IdleWorstPerformers {...reportParams} />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <IdleReportDriverTable {...reportParams} />
        </Grid>
      </Grid>
    </div>
  );
};

export const IdleReports = () => {
  return (
    <IdleReportProvider>
      <MuiPickersUtilsProvider utils={ProLogsDateFnsUtils}>
        <IdleReportsContent />
      </MuiPickersUtilsProvider>
    </IdleReportProvider>
  );
};

export default IdleReports;
